import {
  ChallengeImage,
  ChallengeShell,
  useChoices,
  usePickHandler,
  type ChallengeProps,
} from "./shared";

/** Listen to the English word, pick the matching picture. Best for non-readers. */
export function AudioToImage({ word, distractors, onAnswer }: ChallengeProps) {
  const { picked, handle, teachOverlay, celebrateOverlay, retryKey } = usePickHandler(word, onAnswer);
  const choices = useChoices(word, distractors, retryKey);

  return (
    <>
      <ChallengeShell
        tag="Listen"
        prompt="Listen and pick the picture"
        speakerText={word.english}
        speakerAudioUrl={word.audioUrl}
        speakerVietnamese={word.vietnamese}
      >
        <div className="grid grid-2" style={{ gap: 12, marginTop: 16 }}>
          {choices.map((c) => {
            const correct = c.id === word.id;
            const isPicked = picked === c.id;
            const cls = picked
              ? isPicked
                ? correct
                  ? "good"
                  : "bad"
                : correct
                  ? "good faded"
                  : "faded"
              : "";
            return (
              <button
                key={c.id}
                className={`choice choice-image ${cls}`}
                onClick={() => handle(c)}
                disabled={!!picked}
              >
                <ChallengeImage className="choice-image-img" src={c.imageUrl} alt={c.english} />
                <span className="choice-en">{c.english}</span>
              </button>
            );
          })}
        </div>
      </ChallengeShell>
      {teachOverlay}{celebrateOverlay}
    </>
  );
}
